import { NgModule } from '@angular/core';

import { LMSConstantsService } from '../constants';
import { BiometricsSerivce } from './biometrics.service';
import { BranchService } from './branch.service';
import { RatesAdnFeesService } from './rates-and-fees.service';
import { UploadFileService } from './upload-file.service';
import { UserAuditTrailService } from './user-audit-trail.service';

@NgModule({
  providers: [
    BranchService,
    UploadFileService,
    //ClientDetailsService,
    //QuoteStoreService,
    UserAuditTrailService,
    RatesAdnFeesService,
    BiometricsSerivce,
    LMSConstantsService
  ]
})
export class RestServicesModule { }
